import axios from "axios";
import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../hooks/useAuthContext";
import { ApiConnectionString } from "../../constants/ApiConntection";
import ConfirmUpdateProfile from "./modals/ConfirmUpdateProfile";
import UploadProfileImgModal from "./modals/UploadProfileImgModal";
import LoadingSpinner from "../../components/LoadingSpinner";
import DeleteProfileImg from "./modals/DeleteProfileImg";
import ProfilePlaceHolder from "../../assets/ProfilePlaceHolder.png";
import SideMenu from "../../components/SideMenu";
import { Dropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function EditProfile({ id, goBack, refreshData }) {
  const { user, dispatch } = useAuthContext();
  const navi = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [firstNameErr, setFirstNameErr] = useState("");
  const [lastName, setLastName] = useState("");
  const [lastNameErr, setLastNameErr] = useState("");
  const [username, setUsername] = useState("");
  const [usernameErr, setUsernameErr] = useState("");
  const [updatedProfile, setUpdatedProfile] = useState(null);
  const [confirmUpdateModal, setConfirmUpdateModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [updateError, setUpdateError] = useState("");
  const [image, setImage] = useState(null);
  const [uploadProfileImgModal, setUploadProfileImgModal] = useState(false);
  const [imgUrl, setImgUrl] = useState(
    `${ApiConnectionString}/api/profileImage/${id}`
  );
  const [deleteImgModal, setDeleteImgModal] = useState(false);

  const setTheImgUrl = (url) => {
    setImgUrl(url);
  };

  const nameRegex = /^[A-Za-z\s-']+$/;

  const cancelModal = () => {
    setConfirmUpdateModal(false);
    setUploadProfileImgModal(false);
    setDeleteImgModal(false);
  };

  const fetchData = async () => {
    try {
      // Start loading
      setIsLoading(true);

      // Make the API request
      const bookingProfileResponse = await axios.get(
        `${ApiConnectionString}/api/BookingProfile/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      // Set data from response
      setFirstName(bookingProfileResponse.data.firstName);
      setLastName(bookingProfileResponse.data.lastName);
      setUsername(bookingProfileResponse.data.username);
      setImage(bookingProfileResponse.data.image);
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching booking profile:", error);
    } finally {
      // Stop loading
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout); // Cleanup timeout on re-run
  }, [user]);

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    let err = false;
    setUsernameErr("");
    setFirstNameErr("");
    setLastNameErr("");

    // First Name Validations
    if (!nameRegex.test(firstName)) {
      err = true;
      setFirstNameErr(
        "Your first name can only include letters, spaces, hyphens, underscores, and apostrophes."
      );
    }
    if (firstName.length < 2) {
      err = true;
      setFirstNameErr(
        "Your first name is too short. It must be at least 2 characters long"
      );
    }
    if (firstName.length > 50) {
      err = true;
      setFirstNameErr(
        "Your first name is too long. It must not be over 50 characters"
      );
    }

    // Last Name Validations
    if (!nameRegex.test(lastName)) {
      err = true;
      setLastNameErr(
        "Your last name can only include letters, spaces, hyphens, underscores, and apostrophes."
      );
    }
    if (lastName.length < 2) {
      err = true;
      setLastNameErr(
        "Your last name is too short. It must be at least 2 characters long"
      );
    }
    if (lastName.length > 50) {
      err = true;
      setLastNameErr(
        "Your last name is too long. It must not be over 50 characters"
      );
    }

    if (!err) {
      const updateProfile = {
        id,
        firstName,
        lastName,
        username,
      };
      setUpdatedProfile(updateProfile);
      setConfirmUpdateModal(true);
    }
    setIsLoading(false);
  };

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="container">
      <p
        className="pointer cancelButton fw-bold mx-2 px-3 epGoBackButton"
        onClick={goBack}
      >
        Go back to My Profiles
      </p>
      <div className="row">
        <div className="col-3 side-menu-container myProfile-sideMenu">
          <SideMenu />
        </div>
        <div className="col bg-white epMargin my-2 p-0 ">
          <div className="blueBanner">
            <p className="text-white p-3 mx-3 fw-bold fontSize20 ">
              Edit Profile
            </p>
          </div>
          <div className="text-center">
            <h3 className="red-text">{username}</h3>
            {!image && (
              <div className="mt-2">
                <div className="d-flex justify-content-center ">
                  <img src={ProfilePlaceHolder} className="circle-crop" />
                </div>
                <br></br>
                <button
                  onClick={() => {
                    setUploadProfileImgModal(true);
                  }}
                  className="profile-blue-button"
                >
                  <a className="fw-bold">Add an image</a>
                </button>
              </div>
            )}

            {image && (
              <div>
                <div className="d-flex justify-content-center ">
                  <Dropdown>
                    <Dropdown.Toggle
                      as="span"
                      id="dropdown-custom-components"
                      className="dropdown-toggle-custom"
                    >
                      <div

                      // onClick={() => club.image && setProfileImgModal(true)}
                      >
                        <img
                          src={image ? imgUrl : ProfilePlaceHolder}
                          alt="Profile Image"
                          className="circle-crop pointer"
                        />
                      </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {image ? (
                        <div>
                          <Dropdown.Item
                            onClick={() => {
                              setUploadProfileImgModal(true);
                            }}
                          >
                            Change
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => {
                              setDeleteImgModal(true);
                            }}
                          >
                            Delete
                          </Dropdown.Item>
                        </div>
                      ) : (
                        <Dropdown.Item
                          onClick={() => {
                            setUploadProfileImgModal(true);
                          }}
                        >
                          Upload Profile Picture
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            )}
            <div className="d-flex justify-content-center">
              <hr className="w-75" />
            </div>

            <form onSubmit={handleSubmit}>
              <div>
                <label className="fw-bold mx-5">First Name:</label>
                <input
                  type="text"
                  id="firstName"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
                {firstNameErr && (
                  <p className="text text-danger">{firstNameErr}</p>
                )}
              </div>
              <div className="d-flex justify-content-center">
                <hr className="w-75" />
              </div>
              <div>
                <label className="fw-bold mx-5">Last Name</label>
                <input
                  type="text"
                  id="lastName"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
                {lastNameErr && (
                  <p className="text text-danger">{lastNameErr}</p>
                )}
              </div>
              <div className="d-flex justify-content-center">
                <hr className="w-75" />
              </div>

              <button className="saveChanges-button mb-2" type="submit">
                <a className="fw-bold ">Save Changes</a>
              </button>
            </form>
          </div>
        </div>

        {confirmUpdateModal && (
          <ConfirmUpdateProfile
            profile={updatedProfile}
            cancelModal={cancelModal}
            goBack={goBack}
            refreshData={refreshData}
          />
        )}
        {uploadProfileImgModal && (
          <UploadProfileImgModal
            id={id}
            cancelModal={cancelModal}
            fetchData={fetchData}
            setTheImgUrl={setTheImgUrl}
          />
        )}
        {deleteImgModal && (
          <DeleteProfileImg
            id={id}
            cancelModal={cancelModal}
            fetchData={fetchData}
          />
        )}
      </div>
    </div>
  );
}
